<template>
  <div class="header-mobile">
    <HeaderLogo :route="{ name: 'prime'}" />
    <div class="actions-group">
      <AccentButton @click="openCreateOrderPopup" class="mr-4">
        <PlusIcon color="white" />
      </AccentButton>
      <Notifications class="mr-2" />
      <BurgerButton :is-open="isMainMenuOpen" @toggle="emitMobileMenuToggle" />
      <CreateOrderPopup ref="createOrderPopup" />
    </div>
  </div>
</template>

<script>
import CreateOrderPopup from '../../create-order-popup';
import HeaderLogo from './header-logo';
import { Notifications } from '@/features/server-notifications';
import { BurgerButton } from '@/shared/ui/burger-button';
import { AccentButton } from '@/shared/ui/form';
import { PlusIcon } from '@/shared/ui/icons';
import { HEADER_MOBILE_EVENTS } from '@/widgets/app-header';

export default {
  props: {
    isMainMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  components: { AccentButton, PlusIcon, Notifications, CreateOrderPopup, HeaderLogo, BurgerButton },
  methods: {
    emitMobileMenuToggle(event) {
      this.$eventBus.$emit(HEADER_MOBILE_EVENTS.HEADER_MOBILE_MENU_TOGGLE, event);
    },
    openCreateOrderPopup() {
      this.$refs.createOrderPopup.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.header-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actions-group {
  display: flex;
  align-items: center;
}

.divider {
  height: 50px;
}
</style>
